import { render, staticRenderFns } from "./RefundProcess.vue?vue&type=template&id=b10e9864"
import script from "./RefundProcess.vue?vue&type=script&lang=js"
export * from "./RefundProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports